"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette, _theme$palette2;
  return {
    login: {
      display: "flex",
      flexDirection: "column",
      "& .mco-login-form": {
        "& svg": {
          width: "24px !important"
        }
      },
      [theme.breakpoints.up("md")]: {
        border: "1px solid ".concat((_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[200]),
        padding: theme.spacing(4)
      }
    },
    headline: {
      color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.primary) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main,
      fontSize: "2rem",
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(2)
    },
    text: {
      marginBottom: theme.spacing(3)
    }
  };
});
var _default = exports.default = styles;